import { MLHelper } from '@bimser/core';
import { loadMessages, locale } from 'devextreme/localization';
import React from 'react';
import azMessages from '../../../BCExtremeGrid/helpers/localization/az';
import ruMessages from '../../../BCExtremeGrid/helpers/localization/ru';
import trMessages from '../../../BCExtremeGrid/helpers/localization/tr';
import deMessages from '../../../BCExtremeGrid/helpers/localization/de';

export const useLocalization = () => {
	const initialized = React.useRef<boolean>(false);

	if (initialized.current) {
		return;
	}

	loadMessages(trMessages);
	loadMessages(azMessages);
	loadMessages(ruMessages);
	loadMessages(deMessages);

	locale(MLHelper.currentLanguage.culture);

	initialized.current = true;
};
